import { render, staticRenderFns } from "./goodsDetail.vue?vue&type=template&id=ea3fb808&scoped=true"
import script from "./goodsDetail.vue?vue&type=script&lang=js"
export * from "./goodsDetail.vue?vue&type=script&lang=js"
import style0 from "./goodsDetail.vue?vue&type=style&index=0&id=ea3fb808&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea3fb808",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ea3fb808')) {
      api.createRecord('ea3fb808', component.options)
    } else {
      api.reload('ea3fb808', component.options)
    }
    module.hot.accept("./goodsDetail.vue?vue&type=template&id=ea3fb808&scoped=true", function () {
      api.rerender('ea3fb808', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/reportCenter/dialog/goodsDetail.vue"
export default component.exports